module.exports = __webpack_public_path__ + "static/media/nutrition.734e43b9.svg";